import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

import ReactToPrint from "react-to-print";

import ResultsHistory from "./ResultsHistory";

import "./PrintStudentResults.css";
import useAcademicYearOptions from "../utils/useAcademicYearOptions";

function PrintStudentResults(props) {
  const [currentAcademicYear] = useAcademicYearOptions({ previousYears: 0 });
  let individualStudentResult = props.individualStudentResult;
  let assessmentResultsByStudent = props.assessmentResultsByStudent;
  let student = props.student;
  let classDetails = props.classDetails;
  let detailedView = props.detailedView;
  let buttonName = props.buttonName;

  console.log(props);

  const currentDate = new Date();
  const currentDay = currentDate.getDate();
  const currentMonth = currentDate.toLocaleString("default", { month: "long" });
  const currentYear = currentDate.getFullYear();
  const academicYear = currentAcademicYear.display;

  const componentRef = useRef();

  return (
    <>
      <StudentPrintable
        individualStudentResult={individualStudentResult}
        assessmentResultsByStudent={assessmentResultsByStudent}
        student={student}
        classDetails={classDetails}
        currentDay={currentDay}
        currentMonth={currentMonth}
        currentYear={currentYear}
        academicYear={academicYear}
        detailedView={detailedView}
        ref={componentRef}
      />

      <ReactToPrint
        content={() => componentRef.current}
        trigger={() => (
          <button
            className={`${detailedView ? "blue-action-button" : "blue-action-button"
              }`}
          >
            {buttonName}
          </button>
        )}
      />
    </>
  );
}

const StudentPrintable = React.forwardRef((props, ref) => (
  <div
    className={`no-break-group ${props.detailedView ? "detailed-print" : ""}`}
  >
    <div
      className="student-printable hide-div landscape-print"
      style={{ minHeight: "100vh", position: "relative", width: "100vw" }}
    >
      {/* Force full width in print */}
      <style>
        {`
          @media print {
            .landscape-print, .landscape-print > div, .results-history-table, .results-history-table table {
              width: 100vw !important;
              max-width: 100vw !important;
              min-width: 100vw !important;
              box-sizing: border-box !important;
            }
            .container, .container-shape, .row, .col, .results-history-table {
              padding-left: 0 !important;
              padding-right: 0 !important;
              margin-left: 0 !important;
              margin-right: 0 !important;
            }
            
            /* Print header should stay with its content */
            .alpaca-print-header {
              page-break-after: avoid !important;
              break-after: avoid !important;
            }
            
            /* For detailed view, add specific page break controls */
            ${props.detailedView ? `
              /* First set of headers and first row should stay together and not have page breaks */
              thead:first-child, 
              thead:first-child tr, 
              thead:first-child th,
              tbody:first-child tr:first-child,
              .print-only-header,
              .print-only-header thead,
              .print-only-header tr,
              table.custom-table > thead:first-child {
                page-break-before: avoid !important;
                break-before: avoid !important;
              }
              
              /* Header should always stay with its first row content */
              thead {
                page-break-after: avoid !important;
                break-after: avoid !important;
              }
              
              /* Each assessment row needs to start on a new page EXCEPT the first one */
              tbody tr.table-row:not(:first-child) {
                page-break-before: always !important;
                break-before: page !important;
              }
              
              /* Keep accordion items together */
              .result-accordian-width {
                page-break-inside: avoid !important;
                break-inside: avoid !important;
              }
              
              /* Headers stay with their content */
              .table-header, .table-row {
                page-break-after: avoid !important;
                break-after: avoid !important;
              }
              
              /* Force the main header to print at the very top with no page breaks */
              .alpaca-print-header ~ div .custom-table {
                page-break-before: avoid !important;
                break-before: avoid !important;
              }
              
              /* Ensure header and first row are grouped together */
              .custom-table thead,
              .custom-table thead + tbody tr:first-child {
                page-break-before: avoid !important;
                break-before: avoid !important;
              }
              
              /* For deep targeting */
              .detailed-print-wrapper .custom-table > thead:first-child {
                page-break-before: avoid !important;
                break-before: avoid !important;
              }
            ` : ''}
          }
        `}
      </style>
      <div ref={ref}>
        {/* Print-only header */}
        <div className="alpaca-print-header">
          <div className="printout-logo" />
          <div className="alpaca-print-header-text">
            <span className="alpaca-print-header-class">
              {props.classDetails?.name || "Class Name"}
            </span>
            <span className="alpaca-print-header-year">
              School Year: {props.academicYear}
            </span>
            <span className="alpaca-print-header-year">
              Student Name: {props.student?.name || "Student Name"}
            </span>
            <span className="alpaca-print-header-powered">
            Powered by ALPACA &copy; {new Date().getFullYear()}
            </span>
          </div>
        </div>

        {/* In detailed view, add a wrapper div that adds classes to each assessment */}
        {props.detailedView ? (
          <div className="detailed-print-wrapper">
            <ResultsHistory
              individualStudentResult={props.individualStudentResult}
              assessmentResultsByStudent={props.assessmentResultsByStudent}
              detailedView={props.detailedView}
              isPrintOut={true}
            />
          </div>
        ) : (
          <Row>
            <ResultsHistory
              individualStudentResult={props.individualStudentResult}
              assessmentResultsByStudent={props.assessmentResultsByStudent}
              detailedView={props.detailedView}
              isPrintOut={true}
            />
          </Row>
        )}

        {/* Print footer inside printable area */}
        {/* <div
          className="alpaca-print-footer"
          style={{
            position: "fixed",
            left: 0,
            bottom: 0,
            width: "100%",
            textAlign: "center",
            fontSize: "0.9rem",
            color: "#888",
            padding: "8px 0",
            background: "white",
            zIndex: 1000,
            display: "block",
          }}
        >
          Powered by ALPACA &copy; {props.currentYear}
        </div> */}
      </div>
    </div>
  </div>
));

export default PrintStudentResults;
